import Vue from 'vue';

/*
 * WebSocket connection helpers. Callbacks are kept per connection index so
 * one monitor point cannot consume another operation's result.
 */
var websock = [];
var callbacks = [];
var waitTimers = [];

Vue.prototype.websock = [];

export function initWebSocket(url, index) {
    if (!url) {
        return;
    }
    var socket = websock[index];
    if (!socket || socket.url !== url || socket.readyState === 3) {
        socket = new WebSocket(url);
        websock[index] = socket;
        Vue.prototype.websock[index] = socket;
    }

    socket.onmessage = function (event) {
        websocketonmessage(event, index);
    };
    socket.onopen = function () {
        websocketOpen();
    };
    socket.onerror = function () {
        console.log("WebSocket连接发生错误");
    };
}

export function sendSock(agentData, index, callback) {
    callbacks[index] = callback;
    var socket = websock[index];
    if (!socket) {
        return;
    }
    if (socket.readyState === 1) {
        return;
    }
    clearTimeout(waitTimers[index]);
    if (socket.readyState === 0) {
        waitTimers[index] = setTimeout(function () {
            sendSock(agentData, index, callback);
        }, 1000);
    }
}

function websocketonmessage(event, index) {
    var callback = callbacks[index];
    if (event && callback) {
        callback(event);
    }
}

export function websocketclose(index) {
    clearTimeout(waitTimers[index]);
    waitTimers[index] = null;
    callbacks[index] = null;
    if (websock[index]) {
        websock[index].close();
        websock[index] = null;
    }
    Vue.prototype.websock[index] = null;
}

function websocketOpen() {
    console.log("连接成功");
}
